import styled from "styled-components";
import Colors from "../../constants/Colors";

export const CalendarAnchor = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  margin-left: 10px;
  text-align: center;
  padding: 10px 14px;
  align-items: center;
  justify-content: space-between;
  width: ${(props) => (props.isMobile ? "100%" : "250px")};
  border-radius: 8px;
  background-color: ${Colors.SPM50};
  border: 1px solid ${Colors.SPM100};
`;

export const HourContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 40px;
  background-color: #0000000d;
  border-radius: 4px;
`;
export const FilterContainer = styled.div`
  width: 200px;
  height: 150px;
  padding: 10px 16px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.5);
`;
export const FilterOptionContainer = styled.div`
  flex-direction: row;
  display: flex;
  margin-bottom: 2px;
`;
//flexDirection: 'row', width: '100%', display: 'flex', justifyContent: 'space-evenly'
export const ListHeaderContainer = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  margin-bottom: 5px;
`;

export const ListHeaderAppointmentContainer = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
`;
//width: '100%', textAlign: 'center' }
export const ListHeaderItemContainer = styled.div<{ flex?: number; width?: number; textAlign?: string }>`
  flex: ${props => props.flex || 'none'};
  width: ${props => props.width ? `${props.width}px` : 'auto'};
  text-align: ${props => props.textAlign || 'left'};
  display: flex;
  align-items: center;
  justify-content: ${props => props.textAlign === 'center' ? 'center' : props.textAlign === 'right' ? 'flex-end' : 'flex-start'};
`;

export const ListHeaderItemAppointmentContainer = styled.div`
  width: 100%;
  text-align: center;
`;
////width: '100%', alignItems: 'center', alignSelf: 'center', justifyContent: 'center', flexDirection: 'row', display: 'flex'

export const ListHeaderItemWithFilterContainer = styled.div<{ flex?: number; width?: number; textAlign?: string }>`
  flex: ${props => props.flex || 'none'};
  width: ${props => props.width ? `${props.width}px` : 'auto'};
  align-items: center;
  align-self: center;
  justify-content: ${props => props.textAlign === 'center' ? 'center' : props.textAlign === 'right' ? 'flex-end' : 'flex-start'};
  flex-direction: row;
  display: flex;
`;
//{ width: '90%', flexDirection: isMobile ? 'column' : 'row', display: 'flex', justifyContent: 'space-between' }
export const CalendarRowContainer = styled.div<{ isMobile?: boolean }>`
  width: 90%;
  flex-direction: ${(props) => (props.isMobile ? "column" : "row")};
  display: flex;
  justify-content: space-between;
`;

export const AppointmentStatusFilterContainer = styled.div`
  width: 220px;
  height: 250px;
  padding: 5px 10px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.5);
`;

export const MobileContainer = styled.div<{ disabled?: boolean }>`
  background-color: ${(props) =>
    props.disabled ? "#F9FAFB66;" : Colors.GRAY50};
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 5px;
  padding-bottom: 10px;
  margin-bottom: 15px;
`;

export const AppointmentStatusContainer = styled.div<{ isSelected: boolean }>`
  flex-direction: row;
  display: flex;
  padding-left: 5px;
  background-color: ${(props) => (props.isSelected ? Colors.SPM200 : "")};
  margin-bottom: 2px;
  cursor: pointer;
  border-radius: 8px;

  &:hover {
    background-color: ${Colors.GRAY200};
  }
`;
